import _ from 'lodash'

import TableOrganization from 'components/TableOrganization'

import Styled from './styled'

export default function TableOrganizationWithData({
  loading,
  dataSource,
  value = {},
  onChange = () => null,
}) {
  const selectedRowKeys = _.map(_.filter(value, { selected: true }), (v) => v.record.key)

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Reporter Status',
      key: 'status',
      render: (text, record) => {
        return _.includes(selectedRowKeys, record?.key) ? 'Active' : 'Inactive'
      },
    },
  ]

  const onSelectRow = ({ level, record, selected }) => {
    const newDataForUpdate = { ...value }

    newDataForUpdate[record.key] = {
      level,
      id: record.id,
      selected,
      record,
    }

    onChange(newDataForUpdate)
  }

  return (
    <Styled className="table-organization-with-data-component">
      <TableOrganization
        loading={loading}
        columns={columns}
        dataSource={dataSource}
        selectedRowKeys={selectedRowKeys}
        editMode
        onSelectRow={onSelectRow}
      />
    </Styled>
  )
}
